import axios, { AxiosResponse } from "axios";
import i18n from "../../i18n";
import apiClient from "./apiClient";
import Cookies from "js-cookie";
import { AuthResponse } from "../../shared/models/AuthResponse";

export const getOrders = async (): Promise<any> => {
  const token = Cookies.get('access_token');
  const role = Cookies.get('role');

  try {
    const url = role === "Администратор"
      ? `https://order.articool.online/orders/orders/get-for-admin`
      : `https://order.articool.online/orders/orders/get`;

    const response: AxiosResponse<any> = await axios.get(
      url,
      {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Ошибка при получении заказов:", error);
    throw error;
  }
};


export const handleCreateDraft = async () => {
  const token = Cookies.get('access_token')
  try {
    const response = await axios.post("https://order.articool.online/orders/orders/create-draft",
      {},
      {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
        },
      });
    return response.data;
  } catch (error) {
    console.error("Ошибка при создании черновика:", error);
    throw error;
  }
};

export const deleteOrder = async (orderId: number) => {
  const token = Cookies.get('access_token')
  try {
    const response = await axios.delete(`https://order.articool.online/orders/orders/${orderId}`,
      {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
        },
      }
    );
    console.log(`Заказ с ID ${orderId} успешно удалён`);
    return response.data;
  } catch (error) {
    console.error("Ошибка при удалении заказа:", error);
    throw error;
  }
};

export const getOrderItemsByOrderId = async (orderId: number): Promise<any> => {
  const token = Cookies.get('access_token');
  const role = Cookies.get('role');

  try {


    const response: AxiosResponse<any> = await axios.get(
      `https://order.articool.online/orders/orders/${orderId}/items`,
      {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Ошибка при получении товаров заказа:", error);
    throw error;
  }
};

export const getOrderById = async (orderId: number): Promise<any> => {
  const token = Cookies.get('access_token');
  const role = Cookies.get('role');

  try {


    const response: AxiosResponse<any> = await axios.get(
      `https://order.articool.online/orders/orders/${orderId}`,
      {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Ошибка при получении заказа:", error);
    throw error;
  }
};

export const deleteOrderItems = async (orderId: number, itemIds: number[]): Promise<void> => {
  const token = Cookies.get('access_token')
  try {
    await axios.delete(`https://order.articool.online/orders/orders/${orderId}/items`, {
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
      },
      data: itemIds,
    });
  } catch (error) {
    console.error("Ошибка при удалении товаров из заказа:", error);
    throw error;
  }
};

export const sendToConfim = async (orderId: Number): Promise<void> => {
  const token = Cookies.get('access_token')
  try {
    await axios.put(`https://order.articool.online/orders/orders/${orderId}/send-to-confirmation`,
      {},
      {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
        },
      });
  } catch (error) {
    console.error("Ошибка при удалении товаров из заказа:", error);
    throw error;
  }
};

export const rejectOrder = async (orderId: Number): Promise<void> => {
  const token = Cookies.get('access_token')
  try {
    await axios.put(`https://order.articool.online/orders/orders/${orderId}/reject`, null, {
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
      },
    });
  } catch (error) {
    console.error("Ошибка при удалении товаров из заказа:", error);
    throw error;
  }
};

interface ReturnItem {
  itemId: number;
  returnedQuantity: number;
  returnReason: string;
}

export const returnOrderItems = async (orderId: number, items: ReturnItem[]): Promise<void> => {
  const token = Cookies.get('access_token');

  try {
    await axios.post(
      `https://order.articool.online/orders/orders/${orderId}/items/return`,
      items,
      {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
        },
      }
    );
  } catch (error) {
    console.error("Ошибка при возврате товаров:", error);
    throw error;
  }
};

interface ReduceItem {
  itemId: number;
  reductCount: number;
  editReason: string;
}

interface ReduceItemsPayload {
  items: ReduceItem[];
  deliveryDate?: string;
}

export const reduceOrderItems = async (orderId: number, payload: ReduceItemsPayload): Promise<void> => {
  const token = Cookies.get('access_token');

  try {
    await axios.post(
      `https://order.articool.online/orders/orders/${orderId}/items/reduce`,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
        },
      }
    );
  } catch (error) {
    console.error("Ошибка при сокращении товаров в заказе:", error);
    throw error;
  }
};

interface AddOrderItem {
  photo: string;
  name: string;
  barcode: string;
  price: number;
  stock: number;
  quantity: number;
  type: string;
  editReason: string;
  reductCount: number;
  returnReason: string;
  returnedQuantity: number;
}

export const addItemsToOrder = async (orderId: number, items: AddOrderItem[]): Promise<void> => {
  const token = Cookies.get('access_token');

  try {
    await axios.post(
      `https://order.articool.online/orders/orders/${orderId}/add-items`,
      items,
      {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
        },
      }
    );
  } catch (error) {
    console.error("Ошибка при добавлении товаров в заказ:", error);
    throw error;
  }
};


export const deleteItemsFromOrder = async (orderId: number, itemIds: number[]): Promise<void> => {
  const token = Cookies.get('access_token');

  try {
    await axios.delete(
      `https://order.articool.online/orders/${orderId}/items`,
      {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
        },
        data: itemIds, // В DELETE-запросах тело передаётся через `data`
      }
    );
  } catch (error) {
    console.error("Ошибка при удалении товаров из заказа:", error);
    throw error;
  }
};

export const getProductList = async (page = 1, size = 10): Promise<any> => {
  const token = Cookies.get('access_token');

  try {
    const response = await axios.post(
      'https://new3.articool.online/files-service/api/v1/private/productList',
      {
        "attrs": ["cf3bcaf2-4ad7-4775-84c1-17ec19b1ab06", "040f90a3-be53-4011-88ae-6fdb8f1a3e73", "64e0764f-20d2-4688-a86b-cac8fcce55a5", "6e218c45-a642-48ab-86e7-5c0af242819b", "940c526b-6001-4b7c-a259-394baf91e716", "9cad4e10-d1ba-4ea9-8305-724aa52ca484"],
        "filter": {
          "condition": "AND",
          "categories_id": [],
          "sort": {},
          "attribute": []
        },
        "pageNumber": page,
        "countOnPage": size,
        "tab": "ALL"
      },
      {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
          "Module": "PRODUCTS",
        }
      }
    );

    return response.data;
  } catch (error) {
    console.error("Ошибка при получении списка продуктов:", error);
    throw error;
  }
};
